import { render, staticRenderFns } from "./suggestFeedBack.vue?vue&type=template&id=eb525268&scoped=true&"
import script from "./suggestFeedBack.vue?vue&type=script&lang=js&"
export * from "./suggestFeedBack.vue?vue&type=script&lang=js&"
import style0 from "./suggestFeedBack.vue?vue&type=style&index=0&id=eb525268&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb525268",
  null
  
)

export default component.exports